module.exports = __webpack_public_path__ + "img/risk-management.c4a7afe2.svg";